export const translations = {
  en: {
    appName: "Krishidut Trading",
    tagline: "Farming essentials delivered to your doorstep",
    home: "Home",
    products: "Products",
    myOrders: "My Orders",
    cart: "Cart",
    login: "Login",
    logout: "Logout",
    admin: "Admin",
    all: "All",
    pesticides: "Pesticides",
    herbicides: "Herbicides",
    fertilizers: "Fertilizers",
    seeds: "Seeds",
    tools: "Tools & Equipment",
    organic_pesticides: "Organic Pesticides",
    organic_produce: "Organic Agro Products",
    residue_free: "Residue-Free Produce",
    addToCart: "Add to Cart",
    buyNow: "Buy Now",
    inCart: "In Cart",
    outOfStock: "Out of Stock",
    perUnit: "per",
    viewDetails: "View Details",
    heroTitle: "Quality farming inputs, at fair prices",
    heroSubtitle: "Pesticides, fertilizers, seeds and tools delivered to your village. Cash on Delivery available.",
    shopNow: "Shop Now",
    browseCategories: "Browse Categories",
    freeDelivery: "Free delivery on orders above ₹500",
    codAvailable: "Cash on Delivery",
    trustedBy: "Trusted by local farmers",
    yourCart: "Your Cart",
    emptyCart: "Your cart is empty",
    startShopping: "Start Shopping",
    subtotal: "Subtotal",
    deliveryFee: "Delivery Fee",
    total: "Total",
    proceedCheckout: "Proceed to Checkout",
    quantity: "Qty",
    remove: "Remove",
    checkout: "Checkout",
    fullName: "Full Name",
    mobileNumber: "Mobile Number",
    address: "Delivery Address",
    village: "Village / Town",
    pincode: "Pincode",
    orderNotes: "Order Notes (optional)",
    placeOrder: "Place Order",
    orderPlaced: "Order Placed Successfully!",
    orderPlacedDesc: "We'll contact you shortly to confirm delivery.",
    orderNumber: "Order Number",
    orderStatus: "Status",
    placed: "Placed",
    packed: "Packed",
    out_for_delivery: "Out for Delivery",
    delivered: "Delivered",
    cancelled: "Cancelled",
    noOrders: "No orders yet",
    continueShopping: "Continue Shopping",
    loginTitle: "Farmer Login",
    loginSubtitle: "Enter your details to continue",
    loginBtn: "Continue",
    adminLogin: "Admin Login",
    username: "Username",
    password: "Password",
    dashboard: "Dashboard",
    orders: "Orders",
    manageProducts: "Manage Products",
    addProduct: "Add Product",
    editProduct: "Edit Product",
    productName: "Product Name",
    productNameHi: "Product Name (Hindi)",
    description: "Description",
    descriptionHi: "Description (Hindi)",
    category: "Category",
    price: "Price (₹)",
    unit: "Unit (e.g. 1kg, 1L)",
    stock: "Stock",
    image: "Image",
    upload: "Upload",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    updateStatus: "Update Status",
    totalOrders: "Total Orders",
    pendingOrders: "Pending Orders",
    delivered_orders: "Delivered",
    totalProducts: "Products",
    totalFarmers: "Farmers",
    revenue: "Revenue",
    search: "Search products...",
    noProducts: "No products found",
    orderSummary: "Order Summary",
    items: "items",
    customer: "Customer",
    orderDate: "Order Date",
    viewOrder: "View",
    orderDetails: "Order Details",
    deliveryDetails: "Delivery Details",
    itemsOrdered: "Items Ordered",
    freeDeliveryEligible: "Free delivery — you saved ₹40!",
    addMoreForFree: "Add ₹{amount} more for free delivery",
    close: "Close",
    productImage: "Product Image",
    imageOptional: "PNG/JPG, max 5MB",
    aboutUs: "About Us",
    aboutText: "Serving farmers with quality inputs since generations. We stock genuine products from trusted brands at fair prices.",
    contact: "Contact",
    footerRights: "All rights reserved.",
    languageLabel: "भाषा",
    settings: "Settings",
    reorder: "Reorder",
    reorderConfirm: "All items from this order have been added to your cart.",
    invoice: "Invoice",
    downloadInvoice: "Download Invoice",
    print: "Print",
    invoiceTitle: "Tax Invoice",
    billTo: "Bill To",
    paymentMethod: "Payment Method",
    itemName: "Item",
    unitPrice: "Unit Price",
    amount: "Amount",
    thankYou: "Thank you for your business!",
    invoiceFooter: "This is a computer-generated invoice.",
    shopSettings: "Shop Settings",
    settingsDesc: "Configure your shop details and WhatsApp number for order notifications",
    shopName: "Shop Name",
    shopAddress: "Shop Address",
    whatsappNumber: "WhatsApp Number (with country code)",
    whatsappHelp: "Enter your WhatsApp number with country code. Example: 919876543210 for India (91 prefix). This is where new order alerts will be sent.",
    shopPhone: "Shop Phone",
    shopEmail: "Shop Email",
    businessHours: "Business Hours",
    businessHoursHelp: "e.g. Mon-Sat: 8:00 AM - 8:00 PM · Sun: Closed",
    openNow: "Open Now",
    closedNow: "Closed Now",
    ownerName: "Owner Name",
    gstNumber: "GST Number",
    mapsUrl: "Google Maps Link",
    directions: "Get Directions",
    proprietor: "Proprietor",
    saveSettings: "Save Settings",
    settingsSaved: "Settings saved",
    notifyShop: "Send order to shop on WhatsApp",
    notifyShopDesc: "Tap below to instantly send this order to the shop on WhatsApp for faster confirmation.",
    sendWhatsApp: "Send WhatsApp",
    whatsappCustomer: "Message customer",
    shareOrderWA: "Share on WhatsApp",
    whatsappNotConfigured: "Owner has not set WhatsApp number yet",
  },
  hi: {
    appName: "कृषिदूत ट्रेडिंग",
    tagline: "खेती का सामान आपके द्वार तक",
    home: "मुख्य",
    products: "उत्पाद",
    myOrders: "मेरे ऑर्डर",
    cart: "कार्ट",
    login: "लॉगिन",
    logout: "बाहर निकलें",
    admin: "एडमिन",
    all: "सभी",
    pesticides: "कीटनाशक",
    herbicides: "खरपतवारनाशक",
    fertilizers: "उर्वरक",
    seeds: "बीज",
    tools: "उपकरण",
    organic_pesticides: "जैविक कीटनाशक",
    organic_produce: "जैविक कृषि उत्पाद",
    residue_free: "अवशेष-मुक्त उत्पाद",
    addToCart: "कार्ट में जोड़ें",
    buyNow: "अभी खरीदें",
    inCart: "कार्ट में है",
    outOfStock: "स्टॉक खत्म",
    perUnit: "प्रति",
    viewDetails: "विवरण देखें",
    heroTitle: "अच्छी गुणवत्ता वाला खेती का सामान, सही दाम पर",
    heroSubtitle: "कीटनाशक, उर्वरक, बीज और उपकरण आपके गाँव तक पहुँचाए जाते हैं। कैश ऑन डिलीवरी उपलब्ध।",
    shopNow: "अभी खरीदें",
    browseCategories: "श्रेणियाँ देखें",
    freeDelivery: "₹500 से ऊपर के ऑर्डर पर मुफ्त डिलीवरी",
    codAvailable: "कैश ऑन डिलीवरी",
    trustedBy: "स्थानीय किसानों का भरोसा",
    yourCart: "आपका कार्ट",
    emptyCart: "आपका कार्ट खाली है",
    startShopping: "खरीदारी शुरू करें",
    subtotal: "उप-योग",
    deliveryFee: "डिलीवरी शुल्क",
    total: "कुल",
    proceedCheckout: "चेकआउट पर जाएँ",
    quantity: "मात्रा",
    remove: "हटाएँ",
    checkout: "चेकआउट",
    fullName: "पूरा नाम",
    mobileNumber: "मोबाइल नंबर",
    address: "डिलीवरी पता",
    village: "गाँव / शहर",
    pincode: "पिनकोड",
    orderNotes: "ऑर्डर नोट (वैकल्पिक)",
    placeOrder: "ऑर्डर करें",
    orderPlaced: "ऑर्डर सफलतापूर्वक दिया गया!",
    orderPlacedDesc: "डिलीवरी की पुष्टि के लिए हम आपसे जल्द ही संपर्क करेंगे।",
    orderNumber: "ऑर्डर नंबर",
    orderStatus: "स्थिति",
    placed: "प्राप्त",
    packed: "पैक किया गया",
    out_for_delivery: "डिलीवरी पर",
    delivered: "पहुँचाया गया",
    cancelled: "रद्द",
    noOrders: "अभी कोई ऑर्डर नहीं",
    continueShopping: "खरीदारी जारी रखें",
    loginTitle: "किसान लॉगिन",
    loginSubtitle: "जारी रखने के लिए विवरण भरें",
    loginBtn: "आगे बढ़ें",
    adminLogin: "एडमिन लॉगिन",
    username: "यूज़रनेम",
    password: "पासवर्ड",
    dashboard: "डैशबोर्ड",
    orders: "ऑर्डर",
    manageProducts: "उत्पाद प्रबंधन",
    addProduct: "उत्पाद जोड़ें",
    editProduct: "उत्पाद संपादित करें",
    productName: "उत्पाद का नाम",
    productNameHi: "उत्पाद का नाम (हिंदी)",
    description: "विवरण",
    descriptionHi: "विवरण (हिंदी)",
    category: "श्रेणी",
    price: "मूल्य (₹)",
    unit: "इकाई (जैसे 1 किग्रा, 1 लीटर)",
    stock: "स्टॉक",
    image: "चित्र",
    upload: "अपलोड",
    save: "सहेजें",
    cancel: "रद्द करें",
    delete: "मिटाएँ",
    edit: "संपादित",
    updateStatus: "स्थिति बदलें",
    totalOrders: "कुल ऑर्डर",
    pendingOrders: "लंबित ऑर्डर",
    delivered_orders: "पहुँचाए गए",
    totalProducts: "उत्पाद",
    totalFarmers: "किसान",
    revenue: "आमदनी",
    search: "उत्पाद खोजें...",
    noProducts: "कोई उत्पाद नहीं मिला",
    orderSummary: "ऑर्डर सारांश",
    items: "आइटम",
    customer: "ग्राहक",
    orderDate: "ऑर्डर की तारीख",
    viewOrder: "देखें",
    orderDetails: "ऑर्डर विवरण",
    deliveryDetails: "डिलीवरी विवरण",
    itemsOrdered: "ऑर्डर किए गए आइटम",
    freeDeliveryEligible: "मुफ्त डिलीवरी — आपने ₹40 बचाए!",
    addMoreForFree: "मुफ्त डिलीवरी के लिए ₹{amount} और जोड़ें",
    close: "बंद करें",
    productImage: "उत्पाद चित्र",
    imageOptional: "PNG/JPG, अधिकतम 5MB",
    aboutUs: "हमारे बारे में",
    aboutText: "पीढ़ियों से किसानों को गुणवत्तापूर्ण सामान प्रदान कर रहे हैं। हम विश्वसनीय ब्रांडों के असली उत्पाद उचित दाम पर रखते हैं।",
    contact: "संपर्क",
    footerRights: "सर्वाधिकार सुरक्षित।",
    languageLabel: "Language",
    settings: "सेटिंग्स",
    reorder: "फिर से ऑर्डर करें",
    reorderConfirm: "इस ऑर्डर के सभी आइटम आपके कार्ट में जोड़ दिए गए हैं।",
    invoice: "बिल",
    downloadInvoice: "बिल डाउनलोड करें",
    print: "प्रिंट करें",
    invoiceTitle: "कर बिल",
    billTo: "किसके नाम पर",
    paymentMethod: "भुगतान प्रकार",
    itemName: "सामान",
    unitPrice: "एक इकाई का दाम",
    amount: "राशि",
    thankYou: "आपके व्यापार के लिए धन्यवाद!",
    invoiceFooter: "यह कंप्यूटर द्वारा बनाया गया बिल है।",
    shopSettings: "दुकान सेटिंग्स",
    settingsDesc: "अपनी दुकान की जानकारी और ऑर्डर notifications के लिए WhatsApp नंबर सेट करें",
    shopName: "दुकान का नाम",
    shopAddress: "दुकान का पता",
    whatsappNumber: "WhatsApp नंबर (देश कोड सहित)",
    whatsappHelp: "अपना WhatsApp नंबर देश कोड सहित लिखें। जैसे: 919876543210 (91 भारत का कोड)। यहीं पर नए ऑर्डर के alerts आएंगे।",
    shopPhone: "दुकान का फोन",
    businessHours: "व्यापार का समय",
    businessHoursHelp: "जैसे: सोम-शनि: सुबह 8 बजे - शाम 8 बजे · रविवार: बंद",
    openNow: "अभी खुला है",
    closedNow: "अभी बंद है",
    shopEmail: "दुकान का ईमेल",
    saveSettings: "सेटिंग्स सहेजें",
    settingsSaved: "सेटिंग्स सहेजी गईं",
    notifyShop: "दुकानदार को WhatsApp पर ऑर्डर भेजें",
    notifyShopDesc: "नीचे बटन दबाकर तुरंत यह ऑर्डर WhatsApp पर दुकानदार को भेजें ताकि जल्दी पुष्टि हो सके।",
    ownerName: "मालिक का नाम",
    gstNumber: "जीएसटी नंबर",
    mapsUrl: "Google Maps लिंक",
    directions: "रास्ता देखें",
    proprietor: "स्वामी",
    sendWhatsApp: "WhatsApp पर भेजें",
    whatsappCustomer: "ग्राहक को WhatsApp करें",
    shareOrderWA: "WhatsApp पर share करें",
    whatsappNotConfigured: "दुकानदार ने अभी WhatsApp नंबर सेट नहीं किया",
  },
};

export const statusColor = {
  placed: "bg-amber-100 text-amber-800 border-amber-200",
  packed: "bg-blue-100 text-blue-800 border-blue-200",
  out_for_delivery: "bg-orange-100 text-orange-800 border-orange-200",
  delivered: "bg-emerald-100 text-emerald-800 border-emerald-200",
  cancelled: "bg-rose-100 text-rose-800 border-rose-200",
};
